let token: string | null = localStorage.getItem('token') ?? '';
let guestToken: string | null = localStorage.getItem('guest_token') ?? '';
let tokenErrorRemoveLogin: string | null = '';
let listeners: ((t: string | null) => void)[] = [];

export const TokenManager = {
    getToken: () => token,
    getGuestToken: () => guestToken,
    getTokenErrorRemoveLogin: () => tokenErrorRemoveLogin,
    setToken: (newToken: string | null) => {
        token = newToken;
        if (newToken) {
            localStorage.setItem('token', newToken);
            localStorage.removeItem('guest_token');
            guestToken = '';
        } else {
            localStorage.removeItem('token');
        }
        listeners.forEach((cb) => cb(newToken));
    },
    setGuestToken: (newToken: string | null) => {
        guestToken = newToken;
        if (newToken) {
            localStorage.setItem('guest_token', newToken);
        } else {
            localStorage.removeItem('guest_token');
        }
        listeners.forEach((cb) => cb(newToken));
    },
    setTokenErrorRemoveLogin: (isValid: string | null) => {
        tokenErrorRemoveLogin = isValid;
        listeners.forEach((cb) => cb(isValid));
    },
    subscribe: (cb: (t: string | null) => void) => {
        listeners.push(cb);
        return () => {
            listeners = listeners.filter((l) => l !== cb);
        };
    },
};
